import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import "./index.css";

// Import pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Solutions from "./pages/Solutions";
import Practices from "./pages/Practices";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import USAJobOpening from "./components/careers/USAJobOpening";
import IndiaJobOpening from "./components/careers/IndiaJobOpening";
import OdooIntegration from "./components/odoo/OdooIntegration";
import OdooServices from "./components/odoo/OdooServices";
import OdooImplementation from "./components/odoo/OdooImplementation";
import OdooCustomization from "./components/odoo/OdooCustomization";
import OdooErpDevelopment from "./components/odoo/ErpDevelopment";
import OffshoreDevelopment from "./components/odoo/OffshoreDevelopment";
import OdooMigration from "./components/odoo/OdooMigration";
import OdooConsultationAndAnalysis from "./components/odoo/OdooConsultationAndAnalysis";
import OdooSupportMaintenance from "./components/odoo/OdooSupportMaintenance";
import OdooUpgrades from "./components/odoo/OdooUpgrades";
import OurTeam from "./pages/OurTeam";
import SuccessFactor from "./components/sap/SuccessFactors";
import SapBtp from "./components/sap/SapBtp";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfServices";

function App() {

  function ExternalRedirect({ to }) {
  useEffect(() => {
    const redirect = () => {
      window.location.replace(to);
    };

    redirect();

    // Handles the case where the page is restored from browser
    // back/forward cache (bfcache) and the effect above doesn't re-fire
    window.addEventListener("pageshow", redirect);

    return () => {
      window.removeEventListener("pageshow", redirect);
    };
  }, [to]);

  return null;
}
// export default ExternalRedirect;
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/products" element={<Products />} />
          <Route path="/practices" element={<Practices />} />
          <Route path="/career" element={<ExternalRedirect to="https://tissatech.com/careers" />} />
          <Route path="/contact-us" element={<ExternalRedirect to="https://tissatech.com/contact" />} />
          {/* <Route path="/contact-us" element={<Contact />} /> */}
          <Route path="/usa-careers" element={<USAJobOpening />} />
          <Route path="/india-careers" element={<IndiaJobOpening />} />
          <Route
            path="/services/odoo-services/odoo-integration"
            element={<OdooIntegration />}
          />
          <Route
            path="/services/odoo-services/odoo-implementation"
            element={<OdooImplementation />}
          />
          <Route
            path="/services/odoo-services/odoo-customization"
            element={<OdooCustomization />}
          />
          <Route
            path="/services/odoo-services/erp-development"
            element={<OdooErpDevelopment />}
          />
          <Route
            path="/services/odoo-services/offshore-development"
            element={<OffshoreDevelopment />}
          />
          <Route
            path="/services/odoo-services/odoo-migration"
            element={<OdooMigration />}
          />
          <Route
            path="/services/odoo-services/odoo-cunsultation"
            element={<OdooConsultationAndAnalysis />}
          />
          <Route
            path="/services/odoo-services/odoo-support-maintenance"
            element={<OdooSupportMaintenance />}
          />
          <Route
            path="/services/odoo-services/odoo-upgrades"
            element={<OdooUpgrades />}
          />
          <Route path="/our-team" element={<OurTeam />} />
          <Route
            path="/services/sap-services/sap-successfactors"
            element={<SuccessFactor />}
          />
          <Route
            path="/services/sap-services/sap-btp"
            element={<SapBtp />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/terms-of-service"
            element={<TermsOfService />}
          />
          {/* <Route
            path="/services/odoo-services/"
            element={<OdooServices />}
          /> */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
